import React from 'react'
import './Hero.css'
import { BsArrowDownCircleFill } from 'react-icons/bs'
import { Container } from 'react-bootstrap'
import StarryCanvas from './StarryCanvas'

const Hero = () => {
  const handleScroll = () => {
    const aboutSection = document.getElementById('about')
    if (aboutSection) {
      const offset = 80
      const targetPosition = aboutSection.getBoundingClientRect().top + window.pageYOffset - offset
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      })
    } else {
      window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })
    }
  }

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact')
    if (contactSection) {
      const offset = 80
      const targetPosition = contactSection.getBoundingClientRect().top + window.pageYOffset - offset
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      })
    }
  }

  return (
    <div className="hero-section-wrapper">
      <StarryCanvas />
      <div className="hero-gradient-overlay" />

      <Container className="hero-content-container">
        <div className="hero-content-inner text-center">
          {/* Role Pill Badge */}
          <div className="hero-badge-container">
            <span className="hero-role-badge">
              <span className="badge-pulse-dot" />
              Technical Consultant &bull; AEM Architect &bull; Cloud Engineer
            </span>
          </div>

          {/* Main Name Heading */}
          <h1 className="hero-title">
            Nithin Dasyam
          </h1>

          {/* Subtitle statement */}
          <p className="hero-subtitle">
            Architecting high-scale digital platforms, modern cloud solutions, and enterprise web experiences.
          </p>

          {/* Quote Card */}
          <div className="hero-quote-card">
            <div className="quote-sparkle">✦</div>
            <blockquote className="hero-blockquote">
              <p className="quote-text">
                &ldquo;It is obvious that putting little white dots on the blue-black is
                not enough to paint a starry sky.&rdquo;
              </p>
              <footer className="quote-author">
                &mdash; <cite title="Vincent van Gogh">Vincent van Gogh</cite>
              </footer>
            </blockquote>
          </div>

          {/* Call to action buttons */}
          <div className="hero-cta-group">
            <button
              type="button"
              className="modern-btn"
              onClick={handleScroll}
            >
              Explore My Journey &darr;
            </button>
            <button
              type="button"
              className="modern-btn-outline"
              onClick={scrollToContact}
            >
              Let's Connect
            </button>
          </div>

          {/* Floating bounce scroll down button */}
          <div className="hero-scroll-indicator">
            <button
              type="button"
              className="arrow-down-circle-button"
              aria-label="Scroll to main content"
              onClick={handleScroll}
            >
              <BsArrowDownCircleFill className="arrow-down-circle" aria-hidden="true" focusable="false" />
            </button>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Hero
